// extracted by mini-css-extract-plugin
export var hidden = "_6y-1";
export var visible = "_6y-0";